/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_RetryInputs */

const en_player_retry = /** @type {(inputs: Player_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retry`)
};

const ja_player_retry = /** @type {(inputs: Player_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`再試行`)
};

const fr_player_retry = /** @type {(inputs: Player_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réessayer`)
};

const de_player_retry = /** @type {(inputs: Player_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiederholen`)
};

/**
* | output |
* | --- |
* | "Retry" |
*
* @param {Player_RetryInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const player_retry = /** @type {((inputs?: Player_RetryInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_RetryInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_player_retry(inputs)
	if (locale === "ja") return ja_player_retry(inputs)
	if (locale === "fr") return fr_player_retry(inputs)
	return de_player_retry(inputs)
});